module.exports = __webpack_public_path__ + "static/media/app-store-connect-graphs-reduced.2a117a0c.jp2";